<div class="container">
  <div class="card">
    <div class="task-head">
      <h4 *ngIf="data['type'] === 'taskPreview'">Preview</h4>
      <h4 *ngIf="data['type'] === 'permittedArea'" style="font-size: 21px;">Allowed Tasking Areas</h4>
      <h4 *ngIf="data['type'] === 'satelliteTracking'">Selected satellite(s) TLE positions</h4>
    </div>
    <div class="preview-details" *ngIf="data['type'] === 'taskPreview'">
      <div>
        <span style="color: gray" class="light-text">Task Name:</span><span class="preview-content"> {{ taskname
          }}</span>
      </div>
      <div>
        <span style="color: gray" class="light-text">Task ID:</span><span class="preview-content"> {{ taskid }}</span>
      </div>
    </div>

    <div style="min-width: 200px; position: relative">
      <div leaflet
            #map
       id="map" style="height: 400px">
      <div id="homeButton" (click)="zoomtoLocation()"  title="View Home">
                            <img src="../../../assets/map-icons/home-icon.svg" />
                          </div>
      </div>
      <div class="logo" id="logoDiv" style="position: absolute; z-index: 1000;">
        <a target='_blank' href='https://tasking.eartheye.space'>
          <img *ngIf="mapFontColor == 'white'" class="logo" src="../../../assets/images/white-logo.png" alt="Logo" />
      
          <img *ngIf="mapFontColor == 'black'" class="logo" src="../../../assets/images/black-logo.png" alt="Logo" />
        </a>
      </div>
      <div id="zoomDiv">
        <div style="display: flex">
          <div style="width: 50%">Zoom level</div>
          {{ zoomLevel }}
        </div>
        <div style="display: flex">
          <div style="width: 50%">Distance</div>
          {{ mapDistance | number : "0.0-2" }} km
        </div>
    </div>
      <div *ngIf="data['type'] === 'taskPreview'" style="
          position: relative;
          background: black;
          color: white;
          z-index: 1;
          top: -35px;
          padding: 3px 8px;
        ">
        <label style="padding-bottom: 5px">AREA OF INTEREST</label>
        <div style="font-size: small">
          <p style="margin-bottom: 5px;">
            <label style="color: lightgray">Geometry:</label>
            {{ taskTarget.type }}
          </p>
          <p>
            <span *ngIf="cordinateLabel === 'Tipping Coordinates'" class="tip-dot"></span>
            <label style="color: lightgray">{{cordinateLabel}} (Lng, Lat):</label><span>
              [{{ coordinates | json | slice: 1:35 }}...]
              <span [matTooltipClass]="'target-tooltip'" [matTooltip]="coordinates | json" matTooltipPosition="left">
                <img style="
                height: 20px;
                position: absolute;
                top: 0;
                right: -32px;
                width: 20px;
                " src="../../../assets/images/mark.png" /></span>
            </span>

          </p>
          <p *ngIf="observationCoordinatesDisplay.length > 0" style="margin-bottom: 5px;">
            <label style="color: lightgray">Geometry:</label>
            {{ observationType }}
          </p>
          <p *ngIf="observationCoordinatesDisplay.length > 0">
            <span class="cue-dot"></span>
            <label style="color: lightgray">Cueing Coordinates (Lng, Lat):</label><span>
            [{{ observationCoordinatesDisplay | json | slice: 1:35 }}...]
            <span [matTooltipClass]="'target-tooltip'" [matTooltip]="observationCoordinatesDisplay | json" matTooltipPosition="left">
                <img style="
                height: 20px;
                position: absolute;
                top: 0;
                right: -32px;
                width: 20px;
                " src="../../../assets/images/mark.png" /></span>
            </span>
          </p>
        </div>
      </div>

      <mat-progress-bar *ngIf="dataLoading && data['type'] === 'satelliteTracking'" class="cesium-progress-bar"
        mode="indeterminate"></mat-progress-bar>

      <div class="d-flex justify-content-center"
        [ngStyle]="{'margin-top': data['type'] === 'taskPreview' ? '-15' : '15px'}">
        <button mat-button class="btn" (keydown)="onKeyPress($event, 'NO')" (click)="onNoClick('NO')">
          Close
        </button>
      </div>
    </div>
  </div>
</div>